export enum SkillBankType {
  Grade = 'Grade',
  Collection = 'Collection',
  Textbook = 'Textbook',
  TextbookGoMath = 'TextbookGoMath',
  TextbookEureka = 'TextbookEureka',
  GenericCurricula = 'GenericCurricula',
  NewSkills = 'NewSkills',
  Folder = 'Folder',
  Assignment = 'Assignment',
  Exam = 'Exam',
  Skill = 'Skill',
  Organization = 'Organization',
  ProblemPreview = 'ProblemPreview',
}

interface Shared<T extends SkillBankType> {
  /** Depth of the item relative to the request */
  depth: number;
  /** The unique identifier of the item */
  id: string;
  /** Localized name of the item */
  name: string;
  /** We use this for requests */
  nameIdentifier: string;
  /** Unique identifier of the parent `Tag` */
  parentId: string | null;
  /** An array of `id`s representing the path to this item, its `id` included */
  path: string[];
  /** The position of this item within its parent */
  position: number;
  /** The type of item */
  type: T;
}

export interface Grade extends Shared<SkillBankType.Grade> {
  /** Localized abbreviation for the item, if necessary */
  abbreviation: string;
}

export interface Skill extends Shared<SkillBankType.Skill> {
  /** When this specific skill was released */
  releasedOn: string;
}

type ExerciseType = Extract<
  SkillBankType,
  SkillBankType.Exam | SkillBankType.Assignment
>;
type FolderType = Exclude<
  SkillBankType,
  | SkillBankType.Grade
  | SkillBankType.Skill
  | ExerciseType
  | SkillBankType.ProblemPreview
>;

export type Tag = Shared<FolderType>;

export interface ProblemPreview extends Shared<SkillBankType.ProblemPreview> {
  skill: Skill;
}

export type GradeList = Grade[];
export type CollectionResponse = Tag[];
export type CollectionDetail = Tag | Skill;
export type CollectionItem = CollectionDetail | ProblemPreview;
export type CollectionDetailResponse = CollectionDetail[];
